import React from 'react';
import { MktTopBarItem } from './TopBar';
import { LinkProps } from './TopBar';
import {
  MktTopBarVariantsTypes,
  MktTopBarVariants,
  MktTopbarTransparentDesktopType,
} from './TopBar';
import clsx from 'clsx';

interface TopBarButtonProps {
  loginItem?: MktTopBarItem;
  signUpItem?: MktTopBarItem;
  linkComponent: React.FC<LinkProps>;
  variant: MktTopBarVariants;
  transparentVariant: MktTopbarTransparentDesktopType;
  isDesktop: boolean;
  scrollY: number;
  scrollThreshold: number;
  fixedVariant: `${MktTopBarVariantsTypes}` | null;
}

export const TopBarButtons: React.FC<TopBarButtonProps> = ({
  loginItem,
  signUpItem,
  linkComponent,
  variant = 'dark',
  transparentVariant,
  isDesktop,
  scrollThreshold,
  scrollY,
  fixedVariant = null,
}) => {
  const Link = linkComponent;
  const isLight = variant === MktTopBarVariantsTypes.light;

  if (loginItem && signUpItem) {
    return (
      <div
        className={
          'wh-flex wh-flex-col wh-gap-3 lg:wh-flex-row lg:wh-gap-[30px] wh-w-full wh-h-full lg:wh-items-center'
        }
      >
        <div className="wh-bg-gold wh-h-[1px] wh-w-full wh-brightness-50 lg:wh-h-[24px] lg:wh-w-[0.5px]" />
        <ul className="wh-w-full wh-h-full wh-flex wh-gap-3 lg:wh-gap-[30px] wh-flex-col lg:wh-flex-row">
          <li className="wh-flex wh-items-center">
            <Link
              className={clsx(
                `wh-flex wh-h-[27px] lg:wh-h-full  wh-w-auto wh-items-center wh-justify-start wh-text-lg wh-font-medium ${
                  isLight || variant === MktTopBarVariantsTypes.transparent
                    ? 'wh-text-blue-dark'
                    : 'wh-text-white'
                } lg:wh-rounded-none lg:wh-border-none lg:hover:wh-text-gold lg:wh-text-base`,
                {
                  'wh-text-white':
                    transparentVariant === 'light' &&
                    isDesktop &&
                    scrollY < scrollThreshold &&
                    !fixedVariant,
                },
                {
                  'wh-text-blue-dark':
                    transparentVariant === 'dark' &&
                    isDesktop &&
                    scrollY < scrollThreshold &&
                    !fixedVariant,
                },
              )}
              to={signUpItem.url}
            >
              {signUpItem.label}
            </Link>
          </li>
          <li className="wh-flex wh-items-center">
            <Link
              className={clsx(
                `wh-flex wh-h-[27px] lg:wh-h-full  wh-w-auto wh-items-center wh-justify-start wh-text-lg wh-font-medium ${
                  isLight || variant === MktTopBarVariantsTypes.transparent
                    ? 'wh-text-blue-dark'
                    : 'wh-text-white'
                } lg:wh-rounded-none lg:wh-border-none  lg:wh-text-base  lg:hover:wh-text-gold `,
                {
                  'wh-text-white':
                    transparentVariant === 'light' &&
                    isDesktop &&
                    scrollY < scrollThreshold &&
                    !fixedVariant,
                },
                {
                  'wh-text-blue-dark':
                    transparentVariant === 'dark' &&
                    isDesktop &&
                    scrollY < scrollThreshold &&
                    !fixedVariant,
                },
              )}
              to={loginItem.url}
            >
              {loginItem.label}
            </Link>
          </li>
        </ul>
      </div>
    );
  }

  const validProp = (signUpItem || loginItem) as MktTopBarItem;

  return (
    <div className="wh-flex wh-flex-col wh-gap-3 lg:wh-flex-row lg:wh-gap-[30px] wh-w-full wh-h-full lg:wh-items-center">
      <div className="wh-bg-gold wh-h-[1px] wh-w-full wh-brightness-50 lg:wh-h-[24px] lg:wh-w-[0.5px]" />
      <Link
        className={clsx(
          `wh-flex wh-h-[27px] lg:wh-h-[24px] wh-w-auto wh-items-center wh-justify-start wh-text-lg wh-font-medium ${
            isLight || variant === MktTopBarVariantsTypes.transparent
              ? 'wh-text-blue-dark'
              : 'wh-text-white'
          } lg:wh-rounded-none lg:wh-border-none  lg:wh-text-base  lg:hover:wh-text-gold `,
          {
            'wh-text-white':
              transparentVariant === 'light' &&
              isDesktop &&
              scrollY < scrollThreshold &&
              !fixedVariant,
          },
          {
            'wh-text-blue-dark':
              transparentVariant === 'dark' &&
              isDesktop &&
              scrollY < scrollThreshold &&
              !fixedVariant,
          },
        )}
        to={validProp.url}
      >
        {validProp.label}
      </Link>
    </div>
  );
};
